<template>
  <div>
    <section class="permanently-close-acc">
      <div class="sidebar-container"></div>
      <div class="main-contents">
        <ul class="breadcrumbs-list">
          <a href="javascript:void(0)" @click="backButton"
            ><li>User Profile</li></a
          >
          <li>&nbsp;>&nbsp;Account Management</li>
        </ul>
        <h2>Temporarily Deactivate Account</h2>
        <v-card>
          <p>
            Hi {{name}}, we understand you need a break in life. Everyone needs
            break once in a while.
          </p>
          <p>
            On opting for this option, your subscription will continue till next
            renewal date. You will have full access to your application till
            your renewal date.
          </p>
          <p>
            Post the renewal date the access to your application will be
            deactivated.
          </p>
          <p>
            Should you want to restart your financial wellness journey you have
            to log-in back to your Nimeya.ai account.
          </p>
          <p>
            The access to your account will be reactivated provided you make the
            subscription payment.
          </p>
          <p>
            The access to your account will be reactivated provided you make the
            subscription payment.
          </p>

          <div class="button-container">
            
            <button class="nemia-button" @click="backButton">CANCEL</button>
            <button class="nemia-button active" @click="otpPage()">
              PROCEED
            </button>
          </div>
        </v-card>
      </div>
    </section>
  </div>
</template>

<script>
import { VERIFY_MOBILE_OTP, SEND_MOBILE_OTP,VERIFY_EMAIL_OTP } from "../../store/actions.type";
export default {
  name: "DeactivateAccount",
  methods: {
    backButton() {
      this.$router.push({ name: "dashboard"}).catch(()=>{});
    },
    otpPage() {
      this.$router.push("/OtpVarification?page=deactivation");
      this.$loading(true);
      this.$store.dispatch(VERIFY_EMAIL_OTP, {
          data:{
            mobile_no:this.$store.getters.getUserDetails.mobile_no,
            aws_cognito_id:atob(localStorage.getItem('cognito_idp')),
          },
          api:'send-otp',
        })
        .then(()=> {
          this.$loading(false);
          if (this.$store.getters.getVerifyEmailOtp.data.status == 'error') {
            console.log(this.$store.getters.getVerifyEmailOtp)
              return [];
          }else{
            swal.fire({
            title: '',
            text: "OTP sent successfully",
            icon: 'success',
            showCancelButton: false,
            confirmButtonColor: '#051d42',
            confirmButtonText: 'OK',
          }).then((result) => {
            this.$loading(false);
          })   
          }
        })
        .catch((error)=> {
          this.$loading(false);
        });
    },
  },
 mounted() {
            this.name = this.$store.getters.getUserSignin.data.name;
  },
};
</script>

<style>
</style>
